// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-title {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}

.view-title {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}

/* .rnvodz57-0-0-beta-47 {
    grid-template-columns: none
}
.grid-template-columns{
    background-color: white;
    grid-template-columns: 416.438px 487.925px 431.638px;
    grid-template-rows: null !important;
    --rdg-header-row-height: 35px;
    --rdg-scroll-height: 105px;
    --rdg-frozen-left-0: 0px;
    --rdg-frozen-left-1: 416.4375px;
    --rdg-frozen-left-2: 904.3625183105469px;
}
.rdg-row{
    background-color: white !important;
    color: black;
}

.rdg-cell, .rdg-cell * {
    background-color: white !important;
    color: black !important;
    
  }
*/

.rdg-selected {
    box-sizing: border-box;
}

.rdg-cell {
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
}
 

/* .grid-template-columns{
    grid-template-columns: auto !important;
} */`, "",{"version":3,"sources":["webpack://./src/custom.css"],"names":[],"mappings":"AACI;IAAA,iBAAsC;IAAtC,iBAAsC;IAAtC,gBAAsC;IAAtC,oBAAsC;IAAtC;AAAsC;;AAItC;IAAA,iBAAsC;IAAtC,iBAAsC;IAAtC,gBAAsC;IAAtC,oBAAsC;IAAtC;AAAsC;;AAG1C;;;;;;;;;;;;;;;;;;;;;;;CAuBC;;AAED;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;;AAGA;;GAEG","sourcesContent":[".agent-title{\n    @apply text-2xl font-medium text-black;\n}\n\n.view-title{\n    @apply text-2xl font-medium text-black;\n}\n\n/* .rnvodz57-0-0-beta-47 {\n    grid-template-columns: none\n}\n.grid-template-columns{\n    background-color: white;\n    grid-template-columns: 416.438px 487.925px 431.638px;\n    grid-template-rows: null !important;\n    --rdg-header-row-height: 35px;\n    --rdg-scroll-height: 105px;\n    --rdg-frozen-left-0: 0px;\n    --rdg-frozen-left-1: 416.4375px;\n    --rdg-frozen-left-2: 904.3625183105469px;\n}\n.rdg-row{\n    background-color: white !important;\n    color: black;\n}\n\n.rdg-cell, .rdg-cell * {\n    background-color: white !important;\n    color: black !important;\n    \n  }\n*/\n\n.rdg-selected {\n    box-sizing: border-box;\n}\n\n.rdg-cell {\n    box-sizing: border-box;\n    border: 1px solid #f2f2f2;\n}\n \n\n/* .grid-template-columns{\n    grid-template-columns: auto !important;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
